<template>
  <div ref="crossSellingGroup">
    <h2 class="mx-auto pb-4 text-center text-3xl font-medium">{{ crossSelling.name }}</h2>
    <div class="container:grid container:grid-cols-2 container:gap-2">
      <template v-for="product in crossSelling.products" :key="product.id">
        <ProductCrossSellingCard
          :cross-selling-product="product"
          @close-cross-selling-modal="$emit('close-cross-selling-modal')"
        >
        </ProductCrossSellingCard>
        <template
          v-for="(subscription, index) in product.extensions?.subscription?.intervalConfigurations"
          :key="subscription.id"
        >
          <ProductCrossSellingCard
            v-if="subscription.productId === product.id"
            :cross-selling-product="product"
            :subscription-index="index"
            @close-cross-selling-modal="$emit('close-cross-selling-modal')"
          >
          </ProductCrossSellingCard>
        </template>
      </template>
    </div>
  </div>
</template>

<script setup>
import ProductCrossSellingCard from "~/templates/components/shop/product/ProductCrossSellingCard.vue";
defineEmits(["close-cross-selling-modal"]);

const { crossSelling } = defineProps(["crossSelling"]);
const crossSellingGroup = ref(null);

useItemListTracking({
  // map crossSelling data onto magnolia tracking meta data
  metadata: { "@id": crossSelling.id, "mgnl:template": "d2c-cross-selling" },
  // @ts-ignore
  items: ref(crossSelling.products),
  rootElement: crossSellingGroup,
});
</script>
